var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
var SvgDeprecatedX = function SvgDeprecatedX(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 7,
    r: 7,
    fill: "#FF1E39"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m8.066 7 1.59-1.59a.476.476 0 0 0 .144-.35.53.53 0 0 0-.143-.367l-.35-.35A.53.53 0 0 0 8.94 4.2a.476.476 0 0 0-.35.143L7 5.934l-1.59-1.59a.476.476 0 0 0-.35-.144.53.53 0 0 0-.367.143l-.35.35a.531.531 0 0 0-.143.366c0 .138.048.255.143.35L5.934 7l-1.59 1.591a.476.476 0 0 0-.144.35c0 .138.048.26.143.366l.35.35a.53.53 0 0 0 .366.143.476.476 0 0 0 .35-.143L7 8.067l1.59 1.59a.476.476 0 0 0 .35.143.53.53 0 0 0 .367-.143l.35-.35a.53.53 0 0 0 .143-.366.476.476 0 0 0-.143-.35l-1.591-1.59Z",
    fill: "#fff"
  })));
};
export default SvgDeprecatedX;